import React, { useState, useContext } from "react";
import useStyles from "./styles";
import {
  TextField,
  Button,
  Typography,
  CircularProgress,
} from "@material-ui/core";
import { LoginModel } from "../../models/Auth.model";
import {
  authenticate,
  getAllUserPermissions,
  getUserProfile,
} from "../../services/user.service";
import { validateEmptyFields } from "../../shared/validate";
import { variableConstant } from "../../constants/Variable.constant";
import { saveAuth, savePermissions } from "../../shared/helpers";
import { SearchContext } from "../../context/SearchContext";
import { hasPermission } from "services/hasPermission";

const LoginForm = (props) => {
  // decalred props from parent component
  const { properties, toggle } = props;
  // declared local Styles @author Sagar
  const classes = useStyles();

  // declared local states @author Sagar
  const [userData, setUserData] = useState(LoginModel);
  const [error, setError] = useState(false);
  const [displayErrorMessage, setDisplayErrorMessage] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [value, setValue] = useContext(SearchContext);
  // textfiled onchange function @author Sagar
  function handleChange(evt) {
    let value = evt.target.value;
    setUserData({
      ...userData,
      [evt.target.name]: value,
    });
  }

  // Login form submit function @author Sagar
  const handleSubmit = (evt) => {
    evt.preventDefault();
    if (validateEmptyFields(userData)) {
      setError(true);
    } else {
      setIsLoading(true);
      setError(false);
      authenticate(userData).then(
        (result) => {
          if (result && result.data.statusCode === 200) {
            let data = result.data.response;
            saveAuth(data).then((token) => {
              if (token) {
                getAllUserPermissions(data.id).then((permission) => {
                  if (permission.data.response) {
                    savePermissions(permission.data.response, value).then(
                      () => {
                        setValue(" ");
                        getUserProfile().then((data) => {
                          if (data.data && data.data.response) {
                            localStorage.setItem(
                              "userTitle",
                              data.data.response.title,
                            );
                            localStorage.setItem(
                              "department",
                              data.data.response.department,
                            );

                            if (data.data.response.title.includes("CLAIMS")) {
                              localStorage.setItem(
                                "searchElement",
                                "claimantName",
                              );
                              localStorage.setItem(
                                "defaultValue",
                                "claimantName-claim/csr",
                              );
                              localStorage.setItem("URL", "claim/csr");
                            } else if (
                              data.data.response.title.includes(
                                "UNDERWRITING",
                              ) ||
                              data.data.response.title.includes("ADJUSTER")
                            ) {
                              localStorage.setItem("searchElement", "policyNo");
                              localStorage.setItem(
                                "defaultValue",
                                "policyNo-get/policy/page/csr",
                              );
                              localStorage.setItem(
                                "URL",
                                "get/policy/page/csr",
                              );
                            } else {
                              localStorage.setItem(
                                "searchElement",
                                hasPermission(["CLAIMS CSR"]) &&
                                  hasPermission(["POLICY CSR"])
                                  ? "claimantName"
                                  : "policyNo",
                              );
                              localStorage.setItem(
                                "defaultValue",
                                hasPermission(["CLAIMS CSR"]) &&
                                  hasPermission(["POLICY CSR"])
                                  ? "claimantName-claim/csr"
                                  : "policyNo-get/policy/page/csr",
                              );
                              localStorage.setItem(
                                "URL",
                                hasPermission(["CLAIMS CSR"]) &&
                                  hasPermission(["POLICY CSR"])
                                  ? "claim/csr"
                                  : "get/policy/page/csr",
                              );
                            }
                            if (data.data.response.title.includes("CLAIMS")) {
                              properties.history.push("/app/claims/claims-CSR");
                            } else {
                              properties.history.push("/app/dashboard");
                            }
                            setIsLoading(false);
                          }
                        });
                      },
                    );
                  } else {
                    setIsLoading(false);
                  }
                });
              }
            });
          } else {
            setError(true);
            setIsLoading(false);
            // setTextError(true);
            setDisplayErrorMessage(result.data.message);
          }
        },
        (error) => {
          setIsLoading(false);
        },
      );
    }
  };

  //Login Forms desgin layout @author Sagar
  return (
    <div className={classes.formSection}>
      <div className={classes.formTitle}>
        <Typography variant="h5" className={classes.loginTitle}>
          {variableConstant.loginTitle}
        </Typography>
      </div>
      <form onSubmit={handleSubmit}>
        <div className={`form-group ${classes.emailFormGroup}`}>
          <TextField
            error={error}
            id="login-email"
            label="UserId"
            variant="outlined"
            size="small"
            name="userId"
            value={userData.userId}
            onChange={handleChange}
            fullWidth
          />
        </div>
        {/* <div className={`form-group ${classes.emailFormGroup}`}>
                    <p className={classes.errorTextStyle}>{displayErrorMessage ? displayErrorMessage :variableConstant.incorrectEmail }</p>
                </div> */}
        <div className={`form-group ${classes.passwordFormGroup}`}>
          <TextField
            error={error}
            id="login-password"
            label="Password"
            variant="outlined"
            size="small"
            name="password"
            value={userData.password}
            onChange={handleChange}
            type="password"
            fullWidth
          />
        </div>
        <div className={`form-group ${classes.forgotFormGroup}`}>
          <p className={classes.errorTextStyle}>
            {displayErrorMessage ? displayErrorMessage : null}
          </p>
          <div
            onClick={toggle}
            color="primary"
            size="large"
            className={classes.forgetLink}
          >
            {variableConstant.forgetPasswordLink}
          </div>
        </div>
        <div className={`form-group ${classes.loginFormGroup}`}>
          <Button
            fullWidth
            variant="contained"
            color="primary"
            size="large"
            type="submit"
            className={classes.loginButton}
            disabled={isLoading}
          >
            {!isLoading ? (
              <span>{variableConstant.loginButtonText}</span>
            ) : (
              <span>
                {" "}
                <CircularProgress size={26} />
              </span>
            )}
          </Button>
        </div>
      </form>
    </div>
  );
};

export default LoginForm;
